import produce from "immer"

import { deepCopy, InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initProjectSettings: types.ProjectSettings = {
    cc: {
        defaultApprovalLevelsAssigned: false,
        defaultResponsesAssigned: false,
        defaultReviewItemTypesAssigned: false,
        defaultLibraryAssigned: false,
        defaultRequirementsTypeAssigned: false,
        defaultRequirementsPriorityAssigned: false,
        defaultRequirementsStatusAssigned: false,
        defaultRequirementsReviewMethodAssigned: false,
        defaultRequirementsSmartComplianceAssigned: false,
    },
    lifecycle: {
        defaultLifecyclesAssigned: false,
    },
    sil: {
        assumption: null,
    },
    rrs: {
        defaultCategoriesAssigned: false,
        defaultTemplatesAssigned: false,
    },
    study: {
        studyFieldsAssigned: false,
        studyFields: {
            description: true,
            manager: true,
            systemStage: true,
            studyStatus: true,
            location: true,
            site: true,
            plant: true,
            group: true,
            unit: true,
            subUnit: true,
        },

        teamMembersFieldsAssigned: false,
        teamMembersFields: {
            company: true,
            title: true,
            department: true,
            competence: true,
            phone: true,
            email: true,
            comments: true,
        },

        sessionFieldsAssigned: false,
        sessionFields: {
            facilitator: true,
            scribe: true,
            comment: true,
        },
    },
}

const initProjectSettingsState: types.ProjectSettingsState = {
    settings: initProjectSettings,
}

const projectSettingsReducer = produce((
    draft: types.ProjectSettingsState = initProjectSettingsState,
    action: ActionTypes = null,
): types.ProjectSettingsState => {
    switch (action.type) {
        case types.SET_PROJECT_SETTINGS:
            draft.settings = action.settings
            return draft

        case types.UPDATE_PROJECT_SETTINGS: {
            const { section, settings } = action.data
            const newSettings = deepCopy(draft.settings)
            Object.keys(settings).forEach((settingId) => {
                if (newSettings[section]) {
                    newSettings[section][settingId] = settings[settingId]
                }
            })
            draft.settings = <types.ProjectSettings>newSettings
            return draft
        }

        default:
            return draft
    }
})
export default projectSettingsReducer
